import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PersonalAgreement } from '../model/personal-agreement.model';
import { AgreementDefinitionDto } from '../model/agreement-definition.dto';
import { HisBackendService} from '../../../../core/service/backend/his-backend.service';

@Injectable({
    providedIn: 'root'
} )
export class PersonalAgreementService {
    private backendService = inject( HisBackendService );

    private readonly API_URL = 'api/v1/cs/psv/agreement';

    public getPersonalAgreement( personId: number, agreementDefinitionId: number ): Observable<PersonalAgreement> {
        return this.backendService.getData( `${this.API_URL}/personalAgreement?personId=${personId}&agreementDefinitionId=${agreementDefinitionId}` ) as Observable<PersonalAgreement>;
    }

    public findAgreementDefinitionById( agreementDefinitionId: number ): Observable<AgreementDefinitionDto> {
        return this.backendService.getData( `${this.API_URL}/definition?agreementDefinitionId=${agreementDefinitionId}` ) as Observable<AgreementDefinitionDto>;
    }

    public updatePersonalAgreements( agreement: PersonalAgreement ): Observable<void> {
        return this.backendService.postData( `${this.API_URL}/updatePersonalAgreements`, agreement ) as Observable<void>;
    }
}
